export default __webpack_public_path__ + "static/media/numberArrow.4ac2af2e.svg";